module.exports = __webpack_public_path__ + "img/resumes.e89cc5aa.png";